(function () {
  var PRICE_UPON_REQUEST = 'Price Upon Request';

  function parseJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getPriceMap() {
    return parseJson(document.querySelector('[id^="RequestOrderVariantPrices-"]'));
  }

  function formatCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    try {
      return (n / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return '$' + (n / 100).toFixed(2);
    }
  }

  /** Quote variants always email/display "Price Upon Request" */
  function priceForVariant(variantId, variantData, asQuote) {
    if (asQuote) return PRICE_UPON_REQUEST;
    var v = variantData;
    if (!v) {
      var map = getPriceMap();
      v = map && map.variants && map.variants[String(variantId)];
    }
    if (!v) return '';
    var cents = Number(v.price);
    var map = getPriceMap();
    var threshold = Number((map && map.threshold) || 1000000);
    var force = map && map.force;
    if (force || cents === 0 || cents >= threshold) return PRICE_UPON_REQUEST;
    if (v.price_money) return v.price_money;
    if (typeof v.price === 'number') return formatCents(v.price);
    return '';
  }

  function isQuoteVariant(variantId, variantData) {
    var map = getPriceMap();
    if (map && map.force) return true;
    var v = variantData || (map && map.variants && map.variants[String(variantId)]);
    if (!v) return false;
    var price = Number(v.price);
    var threshold = Number((map && map.threshold) || 1000000);
    return price === 0 || price >= threshold;
  }

  /** Show "Price Upon Request" on product page when RO mode is on */
  function syncPriceLabel(isQuote) {
    document.querySelectorAll('[data-ro-price-label]').forEach(function (el) {
      if (!isQuote) el.remove();
      else {
        var span = el.querySelector('.price-item--request-order');
        if (span) span.textContent = PRICE_UPON_REQUEST;
      }
    });

    document.querySelectorAll('.price-item--request-order').forEach(function (span) {
      span.textContent = PRICE_UPON_REQUEST;
    });

    if (!isQuote) return;

    var hosts = document.querySelectorAll(
      '.product__info-container, .product__info-wrapper, .product__info-container--sticky'
    );
    hosts.forEach(function (host) {
      if (host.querySelector('.price--request-order, [data-ro-price-label]')) return;
      var price = host.querySelector('.price');
      var el = document.createElement('div');
      el.className = 'price price--request-order';
      el.setAttribute('data-ro-price-label', '1');
      el.innerHTML =
        '<div class="price__container"><span class="price-item price-item--request-order">' +
        PRICE_UPON_REQUEST +
        '</span></div>';
      if (price) price.insertAdjacentElement('afterend', el);
      else host.insertBefore(el, host.firstChild);
    });
  }

  function setMode(isQuote) {
    document.documentElement.classList.toggle('request-order-mode', isQuote);
    document.body.classList.toggle('request-order-mode', isQuote);
    syncPriceLabel(isQuote);

    document.querySelectorAll('[data-ro-buy-buttons]').forEach(function (wrap) {
      var quoteMode = isQuote;
      if (wrap.getAttribute('data-force-quote') === 'true') {
        quoteMode = true;
      }
      var quote = wrap.querySelector('.ro-quote-wrap');
      var atc = wrap.querySelector('.ro-atc-wrap');
      var pickup = wrap.querySelector('.ro-pickup-wrap');
      if (quote) quote.hidden = !quoteMode;
      if (atc) atc.hidden = quoteMode;
      if (pickup) pickup.hidden = quoteMode;
    });
  }

  function updateTriggerDataset(variantId, variantData) {
    var quote = isQuoteVariant(variantId, variantData);
    var money = priceForVariant(variantId, variantData, quote);
    document.querySelectorAll('[data-request-order-open]').forEach(function (btn) {
      if (!variantData && !variantId) return;
      btn.dataset.variantId = String(variantId);
      if (variantData && variantData.title) btn.dataset.variantTitle = variantData.title;
      if (variantData && variantData.sku != null) btn.dataset.sku = variantData.sku || '';
      btn.dataset.price = money || PRICE_UPON_REQUEST;
    });
  }

  function applyVariant(variantId) {
    var map = getPriceMap();
    if (!map) return;

    if (map.force) {
      setMode(true);
      if (map.variants && map.variants[variantId]) {
        updateTriggerDataset(variantId, map.variants[variantId]);
      } else {
        updateTriggerDataset(variantId, null);
      }
      return;
    }

    var variant = map.variants && map.variants[variantId];
    if (!variant) return;

    var isQuote = isQuoteVariant(variantId, variant);
    setMode(isQuote);
    updateTriggerDataset(variantId, variant);
  }

  function getSelectedVariantId() {
    var input = document.querySelector(
      '.ro-quote-wrap ~ .ro-atc-wrap .product-variant-id, .ro-atc-wrap .product-variant-id, product-form input.product-variant-id, form[action*="/cart/add"] input[name="id"], input.product-variant-id[name="id"]'
    );
    if (input && input.value) return String(input.value);

    var params = new URLSearchParams(window.location.search);
    if (params.get('variant')) return params.get('variant');

    var map = getPriceMap();
    if (map && map.variants) {
      return Object.keys(map.variants)[0];
    }
    return null;
  }

  function initVariantSwitch() {
    if (!getPriceMap()) return;

    var id = getSelectedVariantId();
    if (id) applyVariant(id);

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && (e.detail.variant || e.detail);
      if (v && v.id) applyVariant(String(v.id));
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches('input.product-variant-id[name="id"], select[name="id"], input[name="id"]')) {
        if (t.value) applyVariant(String(t.value));
      }
    });

    document.addEventListener('change', function (e) {
      if (!e.target.closest('variant-selects, variant-radios, .product-form__input')) return;
      setTimeout(function () {
        var current = getSelectedVariantId();
        if (current) applyVariant(current);
      }, 10);
    });

    var _push = history.pushState;
    history.pushState = function () {
      _push.apply(this, arguments);
      var params = new URLSearchParams(window.location.search);
      if (params.get('variant')) applyVariant(params.get('variant'));
    };
    window.addEventListener('popstate', function () {
      var params = new URLSearchParams(window.location.search);
      if (params.get('variant')) applyVariant(params.get('variant'));
    });
  }

  function initModal() {
    var modal = document.getElementById('RequestOrderModal');
    if (!modal) return;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var form = document.getElementById('RequestOrderForm');
    var submitBtn = document.getElementById('RequestOrderSubmit');
    var qtyInput = document.getElementById('RequestOrderQty');
    var messageInput = document.getElementById('RequestOrderMessage');

    var fields = {
      product_title: modal.querySelector('[data-ro-field="product_title"]'),
      product_id: modal.querySelector('[data-ro-field="product_id"]'),
      variant_id: modal.querySelector('[data-ro-field="variant_id"]'),
      variant_title: modal.querySelector('[data-ro-field="variant_title"]'),
      sku: modal.querySelector('[data-ro-field="sku"]'),
      price: modal.querySelector('[data-ro-field="price"]'),
      product_url: modal.querySelector('[data-ro-field="product_url"]'),
      quantity_hidden: modal.querySelector('[data-ro-field="quantity_hidden"]')
    };

    var summaryTitle = modal.querySelector('[data-ro-summary-title]');
    var summaryMeta = modal.querySelector('[data-ro-summary-meta]');

    function openModal(btn) {
      var data = btn.dataset || {};
      var variantId = data.variantId || getSelectedVariantId() || '';

      var map = getPriceMap();
      var variant = map && map.variants && map.variants[String(variantId)];
      if (variant) {
        updateTriggerDataset(variantId, variant);
        data = btn.dataset;
      }

      var resolvedPrice = PRICE_UPON_REQUEST;

      if (fields.product_title) fields.product_title.value = data.productTitle || '';
      if (fields.product_id) fields.product_id.value = data.productId || '';
      if (fields.variant_id) fields.variant_id.value = variantId;
      if (fields.variant_title) {
        fields.variant_title.value =
          (variant && variant.title) || data.variantTitle || '';
      }
      if (fields.sku) {
        fields.sku.value =
          (variant && variant.sku != null ? variant.sku : data.sku) || '';
      }
      if (fields.price) fields.price.value = resolvedPrice;
      if (fields.product_url) fields.product_url.value = data.productUrl || '';

      if (summaryTitle) summaryTitle.textContent = data.productTitle || '';
      if (summaryMeta) {
        var parts = [];
        var vTitle = (variant && variant.title) || data.variantTitle;
        if (vTitle && vTitle !== 'Default Title') parts.push(vTitle);
        var skuVal = (variant && variant.sku) || data.sku;
        if (skuVal) parts.push('SKU: ' + skuVal);
        summaryMeta.textContent = parts.join(' · ');
        summaryMeta.style.display = summaryMeta.textContent ? '' : 'none';
      }

      modal.hidden = false;
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('request-order-open');

      var nameInput = document.getElementById('RequestOrderName');
      if (nameInput) setTimeout(function () { nameInput.focus(); }, 50);
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('hidden', 'hidden');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('request-order-open');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Request';
      }
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-request-order-open]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        openModal(openBtn);
        return;
      }
      var closeEl = e.target.closest('[data-request-order-close]');
      if (closeEl && !e.target.closest('form')) {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (form) {
      form.addEventListener('submit', function () {
        var vid =
          (fields.variant_id && fields.variant_id.value) ||
          getSelectedVariantId() ||
          '';
        var finalPrice = PRICE_UPON_REQUEST;
        if (fields.price) fields.price.value = finalPrice;
        if (fields.variant_id && vid) fields.variant_id.value = vid;

        var map = getPriceMap();
        var v = map && map.variants && map.variants[String(vid)];
        if (v && fields.variant_title) fields.variant_title.value = v.title || fields.variant_title.value;
        if (v && fields.sku) fields.sku.value = v.sku || fields.sku.value || '';

        var qty = qtyInput ? qtyInput.value : '1';
        if (fields.quantity_hidden) fields.quantity_hidden.value = qty;

        var userMsg = messageInput ? messageInput.value.trim() : '';
        if (userMsg.indexOf('--- REQUEST ORDER ---') === 0) {
          var msgIdx = userMsg.indexOf('Message:');
          userMsg = msgIdx >= 0 ? userMsg.slice(msgIdx + 8).trim() : '';
          if (userMsg === '(no message)') userMsg = '';
        }

        var lines = [
          '--- REQUEST ORDER ---',
          'Product: ' + (fields.product_title && fields.product_title.value),
          'Variant: ' + (fields.variant_title && fields.variant_title.value),
          'SKU: ' + (fields.sku && fields.sku.value),
          'Price: ' + finalPrice,
          'Product ID: ' + (fields.product_id && fields.product_id.value),
          'Variant ID: ' + vid,
          'URL: ' + (fields.product_url && fields.product_url.value),
          'Quantity: ' + qty,
          'Phone: ' + ((document.getElementById('RequestOrderPhone') || {}).value || ''),
          'Name: ' + ((document.getElementById('RequestOrderName') || {}).value || ''),
          '',
          'Message:',
          userMsg || '(no message)'
        ];
        if (messageInput) messageInput.value = lines.join('\n');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending...';
        }
      });
    }

    if (form && form.querySelector('[data-ro-success]')) {
      openModal({
        dataset: {
          productTitle: (fields.product_title && fields.product_title.value) || 'Request sent',
          productId: '',
          variantId: '',
          variantTitle: '',
          sku: '',
          price: PRICE_UPON_REQUEST,
          productUrl: ''
        }
      });
    }
  }

  function init() {
    initModal();
    initVariantSwitch();
    if (document.documentElement.classList.contains('request-order-mode')) {
      syncPriceLabel(true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
